// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:EYyq0E */\n.m2uNu{animation:_4zKH5 2s cubic-bezier(.4,0,.6,1) infinite;background-color:var(--audio-background-highlight);border-radius:var(--audio-radius-1)}@keyframes _4zKH5{0%,100%{opacity:1}50%{opacity:.5}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": "m2uNu",
	"pulse": "_4zKH5"
};
export default ___CSS_LOADER_EXPORT___;
